// Popup Modal (PPM) — Tab Navigation & Open/Close Logic

// ── Global toggleCard ─────────────────────────────────────────────────────────
// Defined here so it works for both PPM and sidebar toggle cards.
// Using closest() means no getElementById lookup — never touches a duplicate.
window.toggleCard = function toggleCard(header) {
    const card = header.closest('.collapsible-card');
    if (!card) return;
    const isOpen = card.dataset.toggleState === 'open';
    card.dataset.toggleState = isOpen ? 'closed' : 'open';

    // Scope data-toggle-elem lookups to this card's container so PPM and
    // sidebar instances with the same key never interfere with each other.
    const toggleElemKey = card.dataset.toggleElem;
    if (toggleElemKey) {
        const scope = card.closest('.ppm-content-box, .model-box, .edit-form-content') || document;
        scope.querySelectorAll('[data-toggle-elem="' + toggleElemKey + '"]').forEach(function (el) {
            el.dataset.toggleElemState = isOpen ? 'hidden' : 'block';
        });
    }
};

(function () {
    const PPM_ID = 'ppm-popup';

    // ── URL helpers ───────────────────────────────────────────────────────────
    var VALID_TABS = ['details', 'rsvp', 'host-info', 'media', 'features', 'settings'];

    function getPPMParam() {
        return new URLSearchParams(window.location.search).get('ppm');
    }

    function setPPMParam(tabName) {
        var url = new URL(window.location.href);
        url.searchParams.set('ppm', tabName);
        history.replaceState(null, '', url.toString());
    }

    function clearPPMParam() {
        var url = new URL(window.location.href);
        url.searchParams.delete('ppm');
        history.replaceState(null, '', url.toString());
    }

    // ── Sub-panel config ──────────────────────────────────────────────────────
    // Maps virtual tab names to their parent tab and display title.
    var SUBPANELS = {
        'event-details':           { parent: 'features', title: 'Event Details' },
        'venue-details':           { parent: 'details',  title: 'Venue & Map' },
        'map-location':            { parent: 'details',  title: 'Map Location' },
        'custom-text':             { parent: 'details',  title: 'Edit Text' },
        'background-music':        { parent: 'features', title: 'Background Music' },
        'cover-image':             { parent: 'features', title: 'Share Cover Image' },
        'branding-logo':           { parent: 'features', title: 'Custom Branding / Logo' },
        'gallery-link':            { parent: 'features', title: 'Photo & Video Gallery' },
        'gift-registry':           { parent: 'features', title: 'Gift Registry' },
        'event-schedule':          { parent: 'features', title: 'Event Schedule' },
        'invite-password':         { parent: 'settings', title: 'Password Protection' },
        'thank-you-page':          { parent: 'features', title: 'Thank You Page' },
        'rsvp-form-fields':        { parent: 'rsvp',     title: 'RSVP Form Fields' },
        'rsvp-personalized-message': { parent: 'rsvp',   title: 'Personalized Message' },
        'rsvp-custom-form':        { parent: 'rsvp',     title: 'Custom Form Fields' },
        'ppm-files':               { parent: 'media',    title: 'Media Files' }
    };

    // ── Tab switching ─────────────────────────────────────────────────────────
    function switchPPMTab(tabName) {
        const popup = document.getElementById(PPM_ID);
        if (!popup) return;

        var subpanel = SUBPANELS[tabName] || null;
        var activeTab = subpanel ? subpanel.parent : tabName;

        // Activate the nav item for this tab (or parent tab for sub-panels)
        popup.querySelectorAll('.ppm-nav-item').forEach(function (item) {
            item.classList.toggle('active', item.dataset.ppmTab === activeTab);
        });

        // Show the matching content box, hide the rest
        popup.querySelectorAll('.ppm-content-box').forEach(function (box) {
            box.dataset.ppmState = box.dataset.ppmTab === tabName ? 'show' : 'hide';
        });

        // Update the header title text
        var titleEl = popup.querySelector('.ppm-tab-title');
        if (titleEl) {
            if (subpanel) {
                titleEl.textContent = subpanel.title;
            } else {
                var activeNav = popup.querySelector('.ppm-nav-item[data-ppm-tab="' + activeTab + '"]');
                titleEl.textContent = activeNav ? activeNav.textContent.trim() : '';
            }
        }

        // Show/hide the sub-panel back button
        var backBtn = popup.querySelector('.ppm-subpanel-back');
        if (backBtn) {
            if (subpanel) {
                backBtn.style.display = 'flex';
                backBtn.dataset.ppmBack = subpanel.parent;
            } else {
                backBtn.style.display = 'none';
            }
        }

        // On mobile the sub-panel back button replaces the mobile-nav back button
        // so that only one back arrow is visible at a time.
        var mobileBackBtn = popup.querySelector('.ppm-mobile-back');
        if (mobileBackBtn) {
            // Suppress the mobile-back button when a sub-panel is open; let the
            // sub-panel back button serve as the single back action.
            // When on a root tab, remove the inline override so the CSS media
            // query makes it visible again on small screens.
            mobileBackBtn.style.display = subpanel ? 'none' : '';
        }

        // Show the media files button only on the main media tab (not in sub-panels)
        var filesBtn = popup.querySelector('.ppm-files-btn');
        if (filesBtn) {
            filesBtn.style.display = (activeTab === 'media' && !subpanel) ? 'flex' : 'none';
        }

        // Reload data into the now-visible PPM container so previous saves appear.
        // Uses requestAnimationFrame so the content-box is visible (offsetParent set)
        // before getActiveEl() is called inside each load function.
        if (tabName === 'gift-registry') {
            requestAnimationFrame(function () {
                if (typeof window.loadGiftRegistryData === 'function') window.loadGiftRegistryData();
            });
        } else if (tabName === 'event-schedule') {
            requestAnimationFrame(function () {
                if (typeof window.loadScheduleData === 'function') window.loadScheduleData();
            });
        } else if (tabName === 'ppm-files') {
            requestAnimationFrame(function () {
                if (typeof window.initPPMFiles === 'function') window.initPPMFiles();
            });
        }
    }

    // ── Open / Close ──────────────────────────────────────────────────────────
    function openPPM(tabName) {
        var popup = document.getElementById(PPM_ID);
        if (!popup) return;
        popup.dataset.popupState = 'show';
        var target = tabName || getActiveTab(popup) || 'details';
        switchPPMTab(target);
        setPPMParam(target);
        // On mobile, skip the nav list and go straight to the content panel
        // when a specific tab is requested programmatically (e.g. from feature cards).
        if (tabName) {
            var ppmEl = popup.querySelector('.ppm-with-navbar');
            if (ppmEl && window.innerWidth <= 640) {
                ppmEl.classList.add('ppm-mobile-content-active');
            }
        }
    }

    function closePPM() {
        var popup = document.getElementById(PPM_ID);
        if (!popup) return;
        popup.dataset.popupState = 'hide';
        // Reset mobile state so nav shows first next time
        var ppmEl = popup.querySelector('.ppm-with-navbar');
        if (ppmEl) ppmEl.classList.remove('ppm-mobile-content-active');
        clearPPMParam();
        // Refresh the invite preview sidebar panel
        if (typeof window.updateInvitePreview === 'function') window.updateInvitePreview();
    }

    function getActiveTab(popup) {
        var active = popup.querySelector('.ppm-nav-item.active');
        return active ? active.dataset.ppmTab : null;
    }

    // ── Event Binding ─────────────────────────────────────────────────────────
    function bindPPMEvents() {
        var popup = document.getElementById(PPM_ID);
        if (!popup) return;

        // Nav tab clicks
        popup.querySelectorAll('.ppm-nav-item').forEach(function (item) {
            item.addEventListener('click', function () {
                var targetTab = item.dataset.ppmTab;

                // Gate non-details tabs for unauthenticated users
                if (!window.userIsAuthenticated && targetTab !== 'details') {
                    var overlayMsg = document.getElementById('ppm-auth-subtitle');
                    if (overlayMsg) overlayMsg.textContent = 'Sign in to unlock all customization tabs.';
                    if (typeof window.showPPMLoginOverlay === 'function') window.showPPMLoginOverlay();
                    return;
                }

                switchPPMTab(targetTab);
                setPPMParam(targetTab);
                // On mobile: slide into content view
                var ppmEl = popup.querySelector('.ppm-with-navbar');
                if (ppmEl && window.innerWidth <= 640) {
                    ppmEl.classList.add('ppm-mobile-content-active');
                }
            });
        });

        // Mobile back button — return to nav list
        popup.querySelectorAll('.ppm-mobile-back').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var ppmEl = popup.querySelector('.ppm-with-navbar');
                if (ppmEl) ppmEl.classList.remove('ppm-mobile-content-active');
            });
        });

        // Sub-panel back button — return to parent tab
        popup.querySelectorAll('.ppm-subpanel-back').forEach(function (btn) {
            btn.addEventListener('click', function () {
                openPPM(btn.dataset.ppmBack || 'details');
            });
        });

        // Files button — opens the media files panel from any tab
        popup.querySelectorAll('.ppm-files-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                // Remember which tab we came from so the back button returns there
                var currentTab = getActiveTab(popup) || 'details';
                if (currentTab !== 'ppm-files') {
                    SUBPANELS['ppm-files'].parent = currentTab;
                }
                switchPPMTab('ppm-files');
                requestAnimationFrame(function () {
                    if (typeof window.initPPMFiles === 'function') window.initPPMFiles();
                });
            });
        });

        // Preview button — close PPM then expand the template to fullscreen
        var previewBtn = document.getElementById('ppmPreviewBtn');
        if (previewBtn) {
            previewBtn.addEventListener('click', function () {
                closePPM();
                var resizeBtn = document.getElementById('resizeBtn');
                if (resizeBtn) {
                    var mainContainer = document.getElementById('mainContainer');
                    if (mainContainer && !mainContainer.classList.contains('expanded')) {
                        resizeBtn.click();
                    }
                }
            });
        }

        // Close button(s)
        popup.querySelectorAll('.ppm-content-close').forEach(function (btn) {
            btn.addEventListener('click', closePPM);
        });

        // Click on overlay to close
        var overlay = popup.querySelector('.model-view-overlay');
        if (overlay) {
            overlay.addEventListener('click', closePPM);
        }

        // Escape key to close
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                var popup = document.getElementById(PPM_ID);
                if (popup && popup.dataset.popupState === 'show') {
                    closePPM();
                }
            }
        });

        // Any element with [data-open-ppm] opens the popup, optionally on a specific tab
        document.querySelectorAll('[data-open-ppm]').forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                openPPM(trigger.dataset.openPpm || 'details');
            });
        });
    }

    // ── Scroll-fade watcher ───────────────────────────────────────────────────
    function initScrollFade() {
        var popup = document.getElementById(PPM_ID);
        if (!popup) return;
        var container = popup.querySelector('.content-container');
        var ppmContent = popup.querySelector('.ppm-content');
        if (!container || !ppmContent) return;

        function updateFade() {
            var atBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 4;
            var noOverflow = container.scrollHeight <= container.clientHeight;
            if (atBottom || noOverflow) {
                ppmContent.classList.add('ppm-scroll-end');
            } else {
                ppmContent.classList.remove('ppm-scroll-end');
            }
        }

        container.addEventListener('scroll', updateFade, { passive: true });
        // Re-check whenever a tab is switched (content height may differ)
        var _origSwitch = window.switchPPMTab;
        window.switchPPMTab = function (tabName) {
            _origSwitch(tabName);
            // Defer until the new tab's display:block takes effect
            requestAnimationFrame(updateFade);
        };
        updateFade();
    }

    // ── RSVP enable/disable gating ────────────────────────────────────────────
    function initRsvpGating() {
        var toggle = document.getElementById('ppmRsvpEnabled');
        var gated  = document.getElementById('ppmRsvpGated');
        var guestsRow = document.getElementById('ppmRsvpGuestsRow');
        if (!toggle || !gated) return;

        function applyState() {
            if (toggle.checked) {
                gated.classList.remove('ppm-rsvp-disabled');
                gated.querySelectorAll('input, select, textarea, button').forEach(function (el) {
                    el.disabled = false;
                });
                if (guestsRow) guestsRow.style.display = '';
            } else {
                gated.classList.add('ppm-rsvp-disabled');
                gated.querySelectorAll('input, select, textarea, button').forEach(function (el) {
                    el.disabled = true;
                });
                if (guestsRow) guestsRow.style.display = 'none';
            }
        }

        toggle.addEventListener('change', applyState);
        applyState(); // run once on load to match initial checked state
    }

    // ── Media inner sub-tabs (Images / Videos) ────────────────────────────────
    function initMediaSubtabs() {
        var popup = document.getElementById(PPM_ID);
        if (!popup) return;
        popup.querySelectorAll('.ppm-media-subtab').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var type = btn.dataset.mediaSubtab;
                var box = btn.closest('.ppm-content-box');
                if (!box) return;
                // Toggle active button
                box.querySelectorAll('.ppm-media-subtab').forEach(function (b) {
                    b.classList.toggle('active', b === btn);
                });
                // Show matching panel, hide others
                box.querySelectorAll('.ppm-media-panel').forEach(function (panel) {
                    panel.style.display = panel.dataset.mediaPanel === type ? '' : 'none';
                });
            });
        });
    }

    // ── Toggle-elem-key checkboxes (container-scoped) ────────────────────────
    // Mirrors initializeToggleElements from invite.js but scopes the target-element
    // query to the checkbox's own container (.ppm-content-box / .model-box) so PPM
    // and sidebar instances with the same key never cross-contaminate each other.
    function initCheckboxToggles() {
        document.querySelectorAll('[data-toggle-elem-key]').forEach(function (input) {
            if (input._toggleElemBound) return;
            input._toggleElemBound = true;

            var toggleKey = input.getAttribute('data-toggle-elem-key');
            var isReverse  = input.getAttribute('data-toggle-reverse') === 'true';

            function updateState() {
                var shouldShow = isReverse ? !input.checked : input.checked;
                // Scope to the checkbox's own container to avoid cross-contaminating
                // the sidebar and PPM instances that share the same data-toggle-elem key.
                var scope = input.closest('.ppm-content-box, .model-box, .edit-form-content') || document;
                scope.querySelectorAll('[data-toggle-elem="' + toggleKey + '"]').forEach(function (el) {
                    el.dataset.toggleElemState = shouldShow ? 'block' : 'hidden';
                });
            }

            updateState(); // apply correct initial state
            input.addEventListener('change', updateState);
        });
    }

    // ── Init ──────────────────────────────────────────────────────────────────
    function initPPM() {
        bindPPMEvents();
        initScrollFade();
        initRsvpGating();
        initMediaSubtabs();
        initCheckboxToggles();

        // Restore PPM state from URL on page load.
        // Accept both main tabs and sub-panel names (sub-panels are opened via openPPM
        // which calls switchPPMTab, which handles SUBPANELS lookup automatically).
        var urlTab = getPPMParam();
        var isValidTab = urlTab && (VALID_TABS.indexOf(urlTab) !== -1 || SUBPANELS.hasOwnProperty(urlTab));
        if (isValidTab) {
            // Unauthenticated users can only land on the details tab
            if (!window.userIsAuthenticated && urlTab !== 'details') {
                urlTab = 'details';
            }
            openPPM(urlTab);
            // On mobile, go straight to the content panel (skip nav list)
            var popup = document.getElementById(PPM_ID);
            if (popup && window.innerWidth <= 640) {
                var ppmEl = popup.querySelector('.ppm-with-navbar');
                if (ppmEl) ppmEl.classList.add('ppm-mobile-content-active');
            }
        } else {
            // Ensure the first tab (details) is active on load without opening
            switchPPMTab('details');
        }
    }

    // Expose globally so other modules can open/switch the popup
    window.openPPM = openPPM;
    window.closePPM = closePPM;
    window.switchPPMTab = switchPPMTab;

    document.addEventListener('DOMContentLoaded', initPPM);
})();
